import { useState, useEffect } from "react";
import LogoImage from "assets/logo/fractional/svg/multicolor/Step2.svg";
import { Box } from "@mui/material";

const Logo = ({ size, sx }) => {
  const [dimensions, setDimensions] = useState({ width: 34, height: 34 });

  useEffect(() => {
    if (size) {
      switch (size) {
        case "small":
          setDimensions({ width: 21, height: 21 });
          break;
        case "medium":
          setDimensions({ width: 34, height: 34 });
          break;
        case "large":
          setDimensions({ width: 52, height: 52 });
          break;
        case "xlarge":
          setDimensions({ width: 102, height: 102 });
          break;
        default:
          setDimensions({ width: 34, height: 34 });
      }
    }
  }, [size]);

  return <Box component="img" src={LogoImage} sx={[dimensions, sx]} />;
};

export default Logo;
